import {useState} from "react";
import MobileTelCard from "../MobileTelCard";

const TelBillSelect=({bill,onSelect,parameter})=>{
   const [selected,setSelected]=useState(null);
    const formattedPrice=new Intl.NumberFormat('fa-IR');

    const handleChange=(e)=>{

        setSelected(e.target.value);
        if(e.target.value==="Tel"){
            onSelect(e.target.value,bill.Tel)

        }else {
            onSelect(e.target.value,bill.TelNow)

        }

    }
   return   <div className="grid grid-cols-1  md:grid-cols-2 gap-3">
                <MobileTelCard bill={bill.Tel} parameter={parameter} onChange={handleChange} type="Tel" title="پایان دوره" selectedType={selected}/>
                <MobileTelCard bill={bill.TelNow} parameter={parameter} onChange={handleChange} type="TelNow" title="میان دوره" selectedType={selected}/>
            </div>
}
export default TelBillSelect;